import React from "react";
import styles from "./progressBar.module.css";

const getColorForMetric = (key) => {
    switch (key) {
        case "FSI & Contract Not Available":
            return "#f7a3a1";
        case "FSI Not Available & Contract Available":
            return "#f7a3a1";
        case "FSI Available & Contract Not Available":
            return "#f7a3a1";
        case "Contract Available & No Source List":
            return "#f7a3a1";
        case "Insufficient Qty & Validity Expired":
            return "#a5d6a7";
        case "Insufficient Qty & Valid Contract":
            return "#a5d6a7";
        case "Insufficient Value & Validity Expired":
            return "#ffe082";
        case "Insufficient Value & Valid Contract":
            return "#ffe082";
        case "Validity expired":
            return "#b2dfdb";
        default:
            return "#BDBDBD";
    }
};

const SegmentedProgressDashboard = ({ data }) => {
    const metrics = [
        { key: "FSI & Contract Not Available", label: " FSI & Contract Not Available" },
        { key: "FSI Not Available & Contract Available", label: "FSI Not Available & Contract Available" },
        { key: "FSI Available & Contract Not Available", label: "FSI Available & Contract Not Available" },
        { key: "Contract Available & No Source List", label: "Contract Available & No Source List" },
        { key: "Insufficient Qty & Validity Expired", label: "Insufficient Qty & Validity Expired" },
        { key: "Insufficient Qty & Valid Contract", label: "Insufficient Qty & Valid Contract" },
        { key: "Insufficient Value & Validity Expired", label: "Insufficient Value & Validity Expired" },
        { key: "Insufficient Value & Valid Contract", label: "Insufficient Value & Valid Contract" },
        { key: "Validity expired", label: "Validity Expired" },
    ];

    const segments = metrics.map((metric) => ({
        key: metric.key,
        label: metric.label,
        value: data?.[metric.key] ?? 0,
        color: getColorForMetric(metric.key),
    }));

    const total = data?.Total || segments.reduce((sum, s) => sum + s.value, 0);

    return (
        <div className={styles.progressDashboard}>
            {/* Labels Row */}
            <div className={styles.labelContainer}>
                {segments.map((item) => (
                    <span key={item.key} className={styles.subHeaderLabel}>
                        {item.label}
                    </span>
                ))}
            </div>

            {/* Segmented Bars */}
            <div className={styles.segmentBar}>
                {segments.map((item) => {
                    const percentage = Math.round((item.value / total) * 100) || 0;
                    return (
                        <div key={item.key} className={styles.segmentWrapper}>
                            <div className={styles.segmentTrack} style={{ background: item.color }}>
                                <div className={styles.segmentContent}>
                                    <span>{item.value}</span>
                                    <span>{percentage}%</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default SegmentedProgressDashboard;
